import { useUser } from "@accurx/concierge/hooks/data/useUser";
import { LabelTagItem } from "@accurx/concierge/schemas/ConversationItemSchema";
import { getPreviewSummaryNote } from "domains/inbox/util/getPreviewSummaryNote";

import { PreviewSummaryTemplate } from "../../PreviewSummaryTemplate";

export type LabelTagProps = {
    conversationItem: LabelTagItem;
};

export const LabelTag = ({ conversationItem }: LabelTagProps) => {
    const userId = conversationItem.createdBy.id;
    const user = useUser({ userId });

    return (
        <PreviewSummaryTemplate
            note={getPreviewSummaryNote(user)}
            messageSummary={`Edited the outcome to be ${conversationItem.label}`}
        />
    );
};
